import { useMutation, useQuery } from "@tanstack/react-query";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import axiosBaseURL from "..";

export const useContractList = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["useContractList"],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/operation/contracts`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useContractByOrderIdList = (order_id?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["contracts by order id,", order_id],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(
        `/operation/order/${order_id}/contracts`,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        }
      );

      return result;
    },
  });
};

export const useGetContractById = (id?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["contracts detail,", id],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/contract/${id}/details`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useContractListByOrderId = (order_id?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["contracts by order id", order_id],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(
        `/operation/contracts?orderId=${order_id}`,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
            // Authorization: authString,
          },
        }
      );

      return result;
    },
  });
};

export const useContractListByUserId = (user_id: string) => {
  return useQuery({
    queryKey: ["contracts by user id", user_id],
    staleTime: 120,
    queryFn: async () => {
      // const result = await supabase.rpc('off_taker_get_my_contracctss', { user_id });

      return "result";
    },
  });
};

export const useUpdateContractStatus = () => {
  const { user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (data: { status: number; id: number }) => {
      const result = await axiosBaseURL.post(
        `/loan/approveReject/${data.status}/${data.id}`,
        {},
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        }
      );

      return result;
    },
  });
};

export const useGetRejectionReasonsByContractById = (id?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["rejection reasons by contract id", id],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(
        `/contract/${id}/rejectionReasons`,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        }
      );

      return result;
    },
  });
};

export const useAddRejectionReason = () => {
  const { user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (data: {
      reason: string;
      id: number;
      status: string;
    }) => {
      const result = await axiosBaseURL.post(
        `/contract/${data.id}/rejectionReasons`,
        { ...data },
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        }
      );

      return result;
    },
  });
};

export const useUpdateRejectionStatus = () => {
  const { user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (data: { status: boolean; id: number }) => {
      const result = await axiosBaseURL.put(
        `/contract/${data.id}/rejectionReasons/${
          data.status === true ? "ACTIVE" : "RESOLVED"
        }`,
        {},
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        }
      );

      return result;
    },
  });
};

export const useFarmingStagesByContractId = (contractId?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["contract_farming_stage", contractId],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(
        `/contract/${contractId}/farming-stage`,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        }
      );

      return result;
    },
  });
};
